import { trackEvent } from "../../track";
import getPageName from "../../helpers/track/getPageName";

/**
 * Push any header links to datalayer when they are in the .header tag
 * Basic DOM markup assumed.
 * 
 * <div class="header">
 *  <div data-gtm-subsection="social">
 *   <button data-gtm-click>Facebook</a>
 *  </div>
 * </div>
 */

const test = ({ target }) => target.closest("[data-bv-modal]");

const push = () => {
    trackEvent({
        event: "click_read_review",
        event_type: "click",
        item_name: document.querySelector("h1")?.textContent || getPageName() || ""
    });
}

export default {
  name: "bv-modal",
  test,
  push
};